import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Avatar, CardHeader, CircularProgress } from '@material-ui/core'
import { FaCheck, FaUser, FaDownload, FaEyeSlash, FaPiggyBank, FaPercent } from 'react-icons/fa'
import { changeScreenB } from '../../../store/actions/navigation.action'
import { show } from '../../../store/actions/roulette.action'
import { IoLogoWhatsapp } from "react-icons/io"
import Fullname from '../../components/Fullname'

const Detail = (props) => {
    const dispatch = useDispatch()
    const id = (props.uid) ? props.uid : null;
    const { award } = useSelector(state => state.rouletteReducer)

    const [isLoading, setLoading] = React.useState(true)
    const [ telefone, setTelefone ] = React.useState(false)

    React.useEffect(() => {
        dispatch(show(id)).then(() => {
            setLoading(false)
        })
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handlePage = (page, user_id = null) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                user_id: user_id
            }
        }))
    }

    return (
        <>
            {isLoading ? <div className="d-flex justify-content-center p-5 bs-bg"><div className="text-center"><CircularProgress /></div></div> :
                <div className="card pt-3 bs-bg">
                    <CardHeader 
                        avatar={
                            <Avatar className="bg-success">
                                <FaCheck />
                            </Avatar>
                        }
                        title={<h5 className="fw-bold m-0 bs-color-b">{award.title}</h5>}
                        subheader={(award.user_id) ? <small className="fw-bold text-success">CONTEMPLADO</small> : <small className="fw-bold text-success">DISPONIVEL</small>} 
                    />

                    {award.position &&
                        <CardHeader 
                            avatar={
                                <Avatar className="avatar-item">
                                    <FaPercent />
                                </Avatar>
                            }
                            title={<h5 className="fw-bold m-0 bs-color-b">{award.position}</h5>}
                            subheader={<small className="fw-bold bs-color">porcento</small> } 
                        />
                    }

                    {(award.user_id) &&
                        <>
                            <hr className="hr-muted m-0"/>
                            <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                            <CardHeader 
                                avatar={
                                    <Avatar className="avatar-item">
                                        <FaUser /> 
                                    </Avatar>
                                }
                                title={<h6 className="fw-bold bs-color-b">{<Fullname fullName={award.user?.name ? award.user?.name.substring(0,25) : award.user?.name} />}</h6>}
                                subheader={
                                    <>
                                    <div className="d-flex justify-content-between">
                                        <span className="d-block pointer bs-color" onClick={() => setTelefone(telefone ? false : true)}>{(telefone) ? award.user?.telefone : <> {award.user?.telefone.substring(5, -1)} ****** <FaEyeSlash /></>}</span>
                                        
                                        <span className="me-2">
                                            <a href={'http://wa.me/55'+award.user?.telefone} target="_blank" rel="noopener noreferrer">
                                                <IoLogoWhatsapp color="#24d366" size={30}/>
                                            </a>
                                        </span>
                                    </div>

                                    <span onClick={() => handlePage('shopping', award.user_id)} className="pointer fw-bold text-danger">Todas compras</span>
                                    </>
                                } 
                            />

                            <hr className="hr-muted m-0"/>

                            <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                            <CardHeader 
                                avatar={
                                    <Avatar className="avatar-item">
                                        <FaDownload />
                                    </Avatar>
                                }
                                title={
                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(award.detail.transaction_amount)}</h6>}
                                subheader={
                                    <span className="d-block bs-color">Horário: {new Intl.DateTimeFormat('pt-BR', {month: '2-digit',day: '2-digit'}).format(new Date(award.time_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(award.time_at))}</span>
                                }
                            />

                            <hr className="hr-muted m-0"/>

                            <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                            <CardHeader 
                                avatar={
                                    <Avatar className="avatar-item">
                                        <FaPiggyBank />
                                    </Avatar>
                                }
                                title={<h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(award.transaction_total.total)}</h6>}
                                subheader={
                                    <span className="d-block bs-color">Compras: {award.transaction_total.count.toLocaleString('pt-BR', {style: 'decimal'})}</span>
                                }
                            />

                            <div className="alert alert-success pt-1 pb-1 m-3 mt-3 mb-1" role="alert">
                                <p className="mb-0">
                                    <strong>Prêmio contemplado na modalidade Roleta Instantânea.</strong>
                                </p>
                            </div>
                        </>
                    }
                    
                    <div className="d-flex justify-content-end p-3">
                        <button className="btn btn-light fw-bold" onClick={() => props.onClose() }>
                            Fechar
                        </button>
                    </div>
                </div>
            }
        </>
    )
}

export default Detail